import React from "react";
import Home from "./HomeComponent";
import Projects from "./Projects";
import SkillsComponent from "./SkillComponent";
import Footer from "./Footer";
import { ProjectComponent } from "./ProjectComponent";

const MainComponent = () => {
  return (
    <div className="scroll-smooth bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-purple-950 to-slate-950 overflow-x-hidden">
      <Home />
      <SkillsComponent />
      <ProjectComponent />
      <Footer />
    </div>
  );
};

export default MainComponent;
